import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";
import Linkify from "react-linkify";
import { useNavigate } from "react-router-dom";
import "./styles.css";

function AlertModal({ isOpen, alerta, onRespond, foiRecusado }) {
  const navigate = useNavigate();

  if (!alerta) {
    return null;
  }

  const isClosable = !alerta.required;

  function openLink() {
    navigate("/abrir-chamado");
  }

  return (
    <Modal
      isOpen={isOpen}
      centered
      backdrop={isClosable ? true : "static"}
      keyboard={isClosable}
      modalClassName={foiRecusado ? "modal-backdrop-dark" : ""}
    >
      <ModalHeader>{alerta.title}</ModalHeader>
      <ModalBody>
        {/* --- MUDANÇA: Aviso condicional DENTRO do modal --- */}
        {/* Se o alerta foi recusado antes, exibe esta mensagem de aviso */}
        {foiRecusado && (
          <Alert color="danger" className="mb-3">
            <center>
              Você optou por recusar este alerta. Para continuar utilizando o
              dash, é necessário aceitá-lo. Se precisar de suporte, entre em
              contato através do botão "Entrar em contato".
            </center>
          </Alert>
        )}

        {/* O corpo original do alerta continua a ser exibido */}
        <div>
          <Linkify>{alerta.body}</Linkify>
        </div>
      </ModalBody>
      <ModalFooter>
        {alerta.required ? (
          <>
            <Button color="primary" onClick={() => onRespond(true)}>
              Aceitar
            </Button>
            {foiRecusado ? (
              <Button color="secondary" onClick={openLink}>
                Entrar em contato
              </Button>
            ) : (
              <Button color="danger" onClick={() => onRespond(false)}>
                Recusar
              </Button>
            )}
          </>
        ) : (
          <Button color="primary" onClick={() => onRespond(true)}>
            Marcar como lida
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default AlertModal;
